import { types } from "mobx-state-tree"
import PaginationOptions from './PaginationOptions'

const InventoryLocationTransactionsUIStore = types.compose(
    PaginationOptions,
    types.model({

    })
)

export default InventoryLocationTransactionsUIStore.create({
    rowsPerPage: 10,
    page: 0
})


// WEBPACK FOOTER //
// ./src/stores/InventoryLocationTransactionsUIStore.js